"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { Button } from "antd";





const Header = () => {
  return (
    <Navbar fluid rounded className="mb-3 border-b-2 py-1 pb-0">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/purchase/'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Purchase</span>
        </Navbar.Brand>
      </div>
      <div className="flex">

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Orders</span>}>
          <Dropdown.Item as={Link} to={'/purchase/request-for-quotation'}>Requests For Quotation</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/purchase-orders'}>Purchase Orders</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/blanket-orders'}>Blanket Orders</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/vendors'}>Vendors</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Products</span>}>
          <Dropdown.Item as={Link} to={'/purchase/products'}>Products</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/packages'}>Product Variants</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Reporting</span>}>

        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/vendorlists'}>Vendor Pricelists</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent">Products</Badge>
          <Dropdown.Item as={Link} to={'/purchase/attributes'}>Product Attributes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/purchase/product-categories'}>Product Categories</Dropdown.Item>

        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;